import React from "react";
import {
  withStyles,
  Card,
  CardContent,
  CardHeader,
  CardActions
} from "@material-ui/core";
import PropTypes from "prop-types";
import cx from "classnames";

import regularCardStyle from "assets/jss/styles/regularCardStyle";

function RegularCard({ ...props }) {
  const {
    classes,
    headerColor,
    plainCard,
    cardTitle,
    cardSubtitle,
    children,
    footer
  } = props;

  const plainCardClasses = cx({
    [" " + classes.cardPlain]: plainCard
  });
  const cardPlainHeaderClasses = cx({
    [" " + classes.cardPlainHeader]: plainCard
  });

  const headerCx = cx(
    classes.cardHeader +
    " " +
    classes[headerColor + "CardHeader"] +
    cardPlainHeaderClasses
  );

  return (
    <Card className={classes.card + plainCardClasses}>
      <CardHeader
        classes={{
          title: classes.cardTitle,
          subheader: classes.cardSubtitle
        }}
        className={headerCx}
        title={cardTitle}
        subheader={cardSubtitle}
      />
      <CardContent>
        {children}
      </CardContent>
      {footer !== undefined ? (
        <CardActions className={classes.cardActions}>
          {footer}
        </CardActions>
      ) : null}
    </Card>
  );
}

RegularCard.defaultProps = {
  headerColor: "purple"
};

RegularCard.propTypes = {
  plainCard: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  headerColor: PropTypes.oneOf(["orange", "green", "red", "blue", "purple"]),
  cardTitle: PropTypes.node,
  cardSubtitle: PropTypes.node,
  content: PropTypes.node,
  footer: PropTypes.node
};

export default withStyles(regularCardStyle)(RegularCard);
